import React, { useState,Children } from "react";
import styles from "./index.module.less";
import { observer } from 'mobx-react-lite';
import { Tooltip,Modal } from "antd";
import infoPng from "@/assets/images/finance/info.png";
import { useStore } from '@/models';
import { Hooks } from "@xt/xtbase";
const {useTranslation} = Hooks;

export default observer(({content="",maxWidth,children}) => {
  const t = useTranslation();

  const { app } = useStore();

  const [showModal, setShowModal] = useState(0);

  const closeModal = ()=>{
    setShowModal(0);
  }

  const renderChildren = (child) => {
    return React.cloneElement(child, {
      onClick: () => {
        setShowModal(1);
      },
    });
  };

  if(app.isH5)
    return <>
      {children ? Children.map(children, renderChildren) : <img src={infoPng} onClick={()=>{setShowModal(1);}}/>}
      <Modal wrapClassName={styles.autoSubscribeModal} open={showModal} width={window.innerWidth < 420 ? window.innerWidth - 20 : 400} centered={true} maskClosable={false} title={
        <div className={styles.headerDiv}>
          <p className={styles.headerTitle}>{t("redPacket.modal.title")}</p>
        </div>
      } closeIcon={false} footer={null} >
        <p className={styles.bodyContent}>{content}</p>
        <div className={styles.btnDiv}>
          <p onClick={() => closeModal() } >{t("finance.confirm")}</p>
        </div>
    </Modal>
    </>

  return <Tooltip zIndex="1100" overlayStyle={maxWidth?{maxWidth:maxWidth+"px"}:{}} title={content} color="rgba(0, 0, 0, 0.6)">
    {children ? children : <img src={infoPng}/>}
  </Tooltip>;
});